import React, { Component } from 'react';
import { connect } from 'react-redux';

export default function(ComposedComponent) {
  class Authentication extends Component {
    // static contextTypes = {
    //   router: React.PropTypes.object
    // }

    componentWillMount() {
      var token = localStorage.getItem("plano_token");
      if (!token) {
          this.props.history.push("/");
      }
    }

    componentWillUpdate(nextProps) {
      var token = localStorage.getItem("plano_token");
      if (!token) {
        this.props.history.push("/");
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  function mapStateToProps(state) {
    return { authenticated: state.auth.authenticated };
  }

  return connect(mapStateToProps)(Authentication);
}


// WEBPACK FOOTER //
// ./src/v3/components/auth/requireAuth.js